import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SharedService } from '../shared.service';
import { ProjectType } from 'src/app/core/models/ProjectType';
import { UIControlTyp } from 'src/app/core/models/UIControlTyp';

@Component({
  standalone: false,
  selector: 'fdb-project-type',
  templateUrl: './project-type.component.html',
  styleUrls: ['./project-type.component.scss']
})
export class ProjectTypeComponent {
  public UIControlTyp = UIControlTyp;
  /** Hiermit können Sie den UIControlTyp entscheiden => Default DropDownList */
  @Input() uiController: UIControlTyp = UIControlTyp.DropDownList;
  // tslint:disable-next-line: no-input-rename
  @Input('values')
  get values() {
    const val = this.uiController === UIControlTyp.MultiSelectList ?
      this.ProjectTypes.map(unit => Number(unit.id)) :
      Number(this.ProjectType.id);
    return val;
  }
  set values(val: string | number | number[]) {
    if (this.uiController === UIControlTyp.MultiSelectList) {
      this.ProjectTypes = (val as number[]).map(id => this.getObjectFromList(id));
    } else {
      this.ProjectType = this.getObjectFromList(val as number);
    }
  }
  @Output() valuesChange = new EventEmitter();

  /** Enthält die ausgewählten Werte bei UIControlTyp.MultiSelectList */
  public ProjectTypes: ProjectType[] = [];
  /** Enthält die ausgewählten Wert bei UIControlTyp.DropDownList */
  public ProjectType: ProjectType;
  /** Enthält die Werte die angezeigt werden dürfen */
  public ProjectTypeList: ProjectType[] = [];
  /** Enthält die Originalliste mit allen Werten */
  private OriginalValues: ProjectType[] = [];

  constructor(private modulService: SharedService) { this.initProjectTypes(); }

  initProjectTypes() {
    this.modulService.getProjectType()
      .subscribe(apiResult => {
        if (!apiResult.isSuccessful) {
          this.modulService.showNotification(apiResult.message, 'error');
        }
        if (apiResult.payload) {
          this.OriginalValues = apiResult.payload;
          this.ProjectTypeList = this.OriginalValues.filter(s => s.isActive === true);
          if (this.uiController === UIControlTyp.DropDownList) {
            this.ProjectTypeList.unshift(new ProjectType().getEmptyModel());
          }
          if (this.uiController === UIControlTyp.MultiSelectList) {
            this.getRefreshSelectedValue();
          }
        }
      },
        err => this.modulService.showNotification(err, 'error'));
  }
  filterenbwunit(value: string) {
    this.ProjectTypeList = this.OriginalValues
      .filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1 && s.isActive === true);
  }

  valueChanged(): void {
    this.valuesChange.emit(this.values);
  }

  getObjectFromList(id: number): ProjectType {
    if (id === 0) { return new ProjectType().getEmptyModel(); }
    const find = this.OriginalValues.find(unit => unit.id === id);
    return find ? find : new ProjectType().setId(id);
  }
  getName() {
    const find = this.getObjectFromList(Number(this.ProjectType.id));
    return find ? find.name : '';
  }
  getRefreshSelectedValue() {
    this.ProjectTypes = this.ProjectTypes.map(x => this.OriginalValues.find(y => y.id === x.id));
  }
}
